"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const styles_1 = require("@material-ui/core/styles");
const InputAdornment_1 = __importDefault(require("../InputAdornment"));
const styles_2 = __importDefault(require("./styles"));
exports.TextField = ({ id, name, label, value, error, disabled, autoFocus, autoComplete, icon, iconPosition, inputProps = {}, inputLabelProps = {}, classes, children, multiline, fullWidth, className, style, rows, rowsMax, type, onChange }) => {
    if (icon) {
        const IconAdornment = (react_1.default.createElement(InputAdornment_1.default, { className: classnames_1.default(classes.icon, iconPosition === 'end' ? classes.iconEnd : classes.iconStart), position: iconPosition }, icon));
        // InputLabelProps.shrink = 'auto' TODO: uncomment when 'auto' PR is merged
        inputProps.notched = false;
        inputLabelProps.classes = { shrink: classes.shrink };
        if (iconPosition === 'end') {
            inputProps.endAdornment = IconAdornment;
        }
        else {
            inputProps.startAdornment = IconAdornment;
            inputLabelProps.className = classes.labelIconStart;
        }
    }
    return (react_1.default.createElement(TextField_1.default, { id: id, name: name, label: label, value: value, error: error, disabled: disabled, autoFocus: autoFocus, autoComplete: autoComplete, multiline: multiline, variant: 'outlined', style: style, rows: rows, rowsMax: rowsMax, type: type, className: classnames_1.default(classes.rootFixedWidth, className, {
            [classes.rootFullWidth]: fullWidth
        }), InputLabelProps: Object.assign({}, inputLabelProps, { classes: {
                root: classes.label,
                shrink: classes.labelShrink
            } }), InputProps: Object.assign({}, inputProps, { classes: {
                root: classnames_1.default(classes.root, {
                    [classes.rootMultiline]: multiline
                }),
                input: classes.input,
                inputMultiline: classes.inputMultiline
            } }), onChange: onChange }, children));
};
exports.TextField.defaultProps = {
    iconPosition: 'end',
    multiline: false
};
exports.TextField.displayName = 'TextField';
exports.default = styles_1.withStyles(styles_2.default)(exports.TextField);
//# sourceMappingURL=TextField.js.map